/** Page size for the owner's share-link list. */
export const SHARE_LINKS_PAGE_SIZE = 20;

/** Width (px) of the share-manager SlidePanel on desktop. */
export const SHARE_MANAGER_PANEL_WIDTH = 460;
